/* eslint-disable */
// @ts-nocheck

import moment from 'moment'
import { useContext, useEffect, useMemo, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { TrashIcon } from '@heroicons/react/24/outline'

import { useBusinessDataQuery } from '@/hooks/business/useBusinessDataQuery'
import { useBusinessPackagesQuery } from '@/hooks/business/useBusinessPackagesQuery'

import useServerBusiness from '../../../api/useServerBusiness'
import useServer from '../../../api/useServerMain'
import CurrencyInput from '../../../components/forms/CurrencyInput'
import Input from '../../../components/forms/Input'
import InputColor from '../../../components/forms/InputColor'
import MultiSelect from '../../../components/forms/Multiselect'
import Toggle from '../../../components/forms/Toggle'
import AlertContainer from '../../../components/misc/AlertContainer'
import Button from '../../../components/misc/Button'
import GenericToggle from '../../../components/misc/GenericToggle'
import Modal from '../../../components/modals/GenericModal'
import { SelectInterface } from '../../../interfaces/InterfacesLocal'
import { ReservationPolicy } from '../../../interfaces/ServerInterfaces'
import { useAppSelector } from '../../../store/hooks'
import { formatCalendar } from '../../../utils/helpers'
import {
  translatePolicyFrequency,
  translatePolicyFrequencyToSp,
} from '../../config/GeneralAdjustment/resourcesTabs/DiscountPolicy'
import { DetailProductContext } from '../DetailProductContainer'

interface SettingProps {
  closeModal: Function
}

const Setting = ({ closeModal }: SettingProps) => {
  const { product, deleteProduct, updateProduct, isFetching } =
    useContext(DetailProductContext)
  const { handleSubmit, control, watch, unregister, setValue } = useForm()
  const [alert, setAlert] = useState(false)
  const {
    getAllReservationPolicy,
    allReservationsPolicy,
    isLoading: isFetchingPolicy,
  } = useServerBusiness()

  //STOCK, MENU, ADDON, SERVICE, VARIATION, COMBO-------------------
  const [visibleForSale, setVisibleForSale] = useState(
    product?.showForSale ||
      product?.isPublicVisible ||
      product?.showWhenOutStock ||
      product?.showRemainQuantities ||
      product?.visibleOnline ||
      false
  )
  const [onSale, setOnSale] = useState(product?.onSale ?? false)
  const publicVisible = watch('isPublicVisible')
  const showForSale = watch('showForSale')
  const showOutStock = watch('showWhenOutStock')
  const showRemainQuant = watch('showRemainQuantities')
  const visibleOnline = watch('visibleOnline')
  const isWholesale = watch('isWholesale') ?? product?.isWholesale

  const { business } = useAppSelector((state) => state.init)
  const { businessData, isLoadingBusinessData, isErrorBusinessData } =
    useBusinessDataQuery({})
  const { businessPackages } = useBusinessPackagesQuery({
    params: { businessId: businessData?.id ?? 0 },
    options: {
      enabled:
        !!businessData?.id && !isLoadingBusinessData && !isErrorBusinessData,
    },
  })
  const { allowRoles: verifyRoles, denyRoles } = useServer()

  useEffect(() => {
    if (!onSale) {
      unregister('onSalePrice')
      setValue('onSalePrice', null)
    }

    if (
      publicVisible === false &&
      showForSale === false &&
      showOutStock === false &&
      showRemainQuant === false &&
      visibleOnline === false
    )
      setVisibleForSale(false)
  }, [
    onSale,
    publicVisible,
    showForSale,
    showOutStock,
    showRemainQuant,
    visibleOnline,
  ])

  useEffect(() => {
    if (!visibleForSale) {
      setValue('showForSale', false)
      setValue('isPublicVisible', false)
      setValue('showWhenOutStock', false)
      setValue('showRemainQuantities', false)
      setValue('visibleOnline', false)
    }
  }, [visibleForSale])

  //----------------------------------------------------------------

  //Asset products -------------------------------------------------
  const enableDepreciation =
    watch('enableDepreciation') ?? product?.enableDepreciation

  //----------------------------------------------------------------

  const [helperState, setHelperSate] = useState(false)
  useEffect(() => {
    if (allReservationsPolicy.length > 0) {
      setHelperSate(true)
    }
  }, [allReservationsPolicy])

  const [policysDicount, policyCancellation] = useMemo(() => {
    if (product?.type === 'SERVICE' && allReservationsPolicy) {
      getAllReservationPolicy({ isActive: true })
      const discount: SelectInterface[] = []
      const cancelation: SelectInterface[] = []
      allReservationsPolicy?.forEach((item) => {
        if (item.type === 'DISCOUNT') {
          discount.push({
            id: item.id,
            name: `${item.quantity} ${translatePolicyFrequencyToSp(
              item.frequency
            )} /${item.discount}%`,
          })
        }
        if (item.type === 'CANCELATION') {
          cancelation.push({
            id: item.id,
            name: `${item.quantity} ${translatePolicyFrequencyToSp(
              item.frequency
            )} /${item.discount}%`,
          })
        }
      })
      return [discount, cancelation]
    }
    return [[], []]
  }, [helperState])

  const [defaultPolicysDicount, defautlPolicyCancellation] = useMemo(() => {
    if (product?.type === 'SERVICE' && allReservationsPolicy) {
      const discount: SelectInterface[] = []
      const cancelation: SelectInterface[] = []
      product.reservationPolicies?.forEach((item) => {
        if (item.type === 'DISCOUNT') {
          discount.push({
            id: item.id,
            name: `${item.quantity} ${translatePolicyFrequencyToSp(
              item.frequency
            )} /${item.discount}%`,
          })
        }
        if (item.type === 'CANCELATION') {
          cancelation.push({
            id: item.id,
            name: `${item.quantity} ${translatePolicyFrequencyToSp(
              item.frequency
            )} /${item.discount}%`,
          })
        }
      })
      return [discount, cancelation]
    }
    return [[], []]
  }, [helperState])

  const [showDiscountPolicy, setShowDiscountPolicy] = useState(
    defaultPolicysDicount.length > 0
  )
  const [showCancelationPolicy, setShowCancelationPolicy] = useState(
    defautlPolicyCancellation.length > 0
  )

  useEffect(() => {
    if (!showDiscountPolicy) {
      setValue('discountPolicyId', [])
    }
    if (!showCancelationPolicy) {
      setValue('cancellationPolicyId', [])
    }
  }, [showDiscountPolicy, showCancelationPolicy])

  const onSubmit: SubmitHandler<Record<string, any>> = (data) => {
    if (data.onSalePrice) {
      const onSalePrice = {
        amount: data.onSalePrice?.price,
        codeCurrency: data.onSalePrice.codeCurrency,
      }
      data = { ...data, onSalePrice }
    }

    data.policyIds = [
      ...(data.discountPolicyId ?? []),
      ...(data.cancellationPolicyId ?? []),
    ]
    const { discountPolicyId, cancellationPolicyId, ...clearData } = data
    updateProduct!(product?.id, clearData)
  }

  const isAdmin = verifyRoles(['ADMIN'])

  // const module_booking =
  //   business?.configurationsKey.find((itm) => itm.key === 'module_booking')
  //     ?.value === 'true'
  const module_booking = businessPackages?.find(
    (itm) => itm.code === 'M_BOOKING'
  )?.isActive
  return (
    <div className="relative h-[40rem] overflow-hidden scroll-auto rounded-md border border-slate-300 p-5 scrollbar-thin">
      <form onSubmit={handleSubmit(onSubmit)}>
        {['STOCK', 'MENU', 'ADDON', 'SERVICE', 'VARIATION', 'COMBO'].includes(
          product?.type ?? ''
        ) && (
          <div className="grid grid-cols-2 items-start overflow-auto p-5 scrollbar-thin scrollbar-thumb-slate-200">
            <div>
              <GenericToggle
                changeState={setVisibleForSale}
                currentState={visibleForSale}
                title="Visible para la venta"
              />
              {visibleForSale && (
                <div className="pl-5">
                  <Toggle
                    control={control}
                    defaultValue={product?.isPublicVisible}
                    name="isPublicVisible"
                    title="Visible carta de venta"
                  />
                  {/* {wooModule && ( */}
                  <Toggle
                    control={control}
                    defaultValue={product?.visibleOnline}
                    name="visibleOnline"
                    title="Visible para internet"
                  />
                  {/* )} */}
                  <Toggle
                    control={control}
                    defaultValue={product?.showForSale}
                    name="showForSale"
                    title="Visible punto de venta"
                  />
                  <Toggle
                    control={control}
                    defaultValue={product?.showWhenOutStock}
                    name="showWhenOutStock"
                    title="Mostrar estando agotado"
                  />
                  <Toggle
                    control={control}
                    defaultValue={product?.showRemainQuantities}
                    name="showRemainQuantities"
                    title="Mostrar cantidades disponibles"
                  />
                </div>
              )}
            </div>

            <div>
              <Toggle
                control={control}
                defaultValue={product?.suggested}
                name="suggested"
                title="Sugerencia de la casa"
              />
            </div>

            <div>
              <div className="flex flex-col gap-0">
                <Toggle
                  control={control}
                  defaultValue={product?.newArrival}
                  name="newArrival"
                  title="Nuevo arribo"
                />
                {product?.newArrival && (
                  <p className="text-xs text-gray-400">{`* Hasta: ${formatCalendar(
                    product.newArrivalAt
                  )}`}</p>
                )}
              </div>

              {product?.type === 'SERVICE' && module_booking && (
                <>
                  <div>
                    <GenericToggle
                      changeState={() =>
                        setShowDiscountPolicy(!showDiscountPolicy)
                      }
                      currentState={showDiscountPolicy}
                      title="Política de descuento"
                    />
                    {policysDicount.length > 0 && showDiscountPolicy && (
                      <MultiSelect
                        byDefault={defaultPolicysDicount.map((item) => item.id)}
                        control={control}
                        data={policysDicount}
                        disabled={!showDiscountPolicy}
                        label="Política de descuento"
                        loading={!policysDicount}
                        name="discountPolicyId"
                      />
                    )}
                  </div>
                  <div>
                    <GenericToggle
                      changeState={() =>
                        setShowCancelationPolicy(!showCancelationPolicy)
                      }
                      currentState={showCancelationPolicy}
                      title="Política de cancelación"
                    />
                    {policyCancellation.length > 0 && showCancelationPolicy && (
                      <MultiSelect
                        byDefault={defautlPolicyCancellation.map(
                          (item) => item.id
                        )}
                        control={control}
                        data={policyCancellation && policyCancellation}
                        disabled={!showCancelationPolicy}
                        label="Política de cancelación"
                        loading={!policyCancellation}
                        name="cancellationPolicyId"
                      />
                    )}
                  </div>
                </>
              )}
              {product?.type === 'STOCK' && (
                <Toggle
                  control={control}
                  defaultValue={product.saleByWeight ?? false}
                  name="saleByWeight"
                  title="Habilitar venta por peso"
                />
              )}
              {['STOCK', 'VARIATION'].includes(product?.type ?? '') && (
                <>
                  <Toggle
                    control={control}
                    defaultValue={product?.isWholesale}
                    name="isWholesale"
                    title="Venta al por mayor"
                  />
                  {!!isWholesale && (
                    <Input
                      control={control}
                      defaultValue={product?.minimunWholesaleAmount}
                      label="Cantidad mínima"
                      name="minimunWholesaleAmount"
                      type="number"
                    />
                  )}
                </>
              )}
            </div>
          </div>
        )}
        {product?.type === 'ASSET' && (
          <>
            <Toggle
              control={control}
              defaultValue={product.enableDepreciation}
              name="enableDepreciation"
              title="Habilitar depreciación"
            />
            {enableDepreciation && (
              <Input
                control={control}
                defaultValue={product.monthlyDepreciationRate}
                label={`Tasa de depreciación mensual (en ${business?.costCurrency})`}
                name="monthlyDepreciationRate"
                type="number"
              />
            )}
          </>
        )}

        {denyRoles(['AUDITOR']) && (
          <div className="flex items-center justify-end gap-2">
            {isAdmin && (
              <Button
                action={() => setAlert(true)}
                color="red-400"
                colorHover="red-400"
                icon={<TrashIcon className="h-5" />}
                name="Eliminar Producto"
                outline
                textColor="red-400"
              />
            )}

            <Button
              color="slate-600"
              disabled={isFetching}
              loading={isFetching}
              name="Actualizar"
              type="submit"
            />
          </div>
        )}
      </form>

      {alert && (
        <Modal close={setAlert} state={alert}>
          <AlertContainer
            onAction={() =>
              deleteProduct && deleteProduct(product?.id ?? null, closeModal)
            }
            onCancel={() => setAlert(false)}
            text="Seguro que desea eliminar este producto?"
            title={`Eliminar ${product?.name}`}
          />
        </Modal>
      )}
    </div>
  )
}

export default Setting
